module.exports = __webpack_public_path__ + "img/PoliceCritical.08d37e57.svg";